export var OffersTitle;
(function (OffersTitle) {
    OffersTitle["Sale"] = "\u041F\u0440\u043E\u0434\u0430\u0436\u0430";
    OffersTitle["Rent"] = "\u0410\u0440\u0435\u043D\u0434\u0430";
})(OffersTitle || (OffersTitle = {}));
